<h3 mat-dialog-title class="color-grey" anessaTranslation="PROJECT.INITIAL.INPUT_LIST.EDIT_TEMPLATE_LOAD"></h3>
<div class="list-header">
  <div class="list-item">
    <div class="list-row">
      <div style="flex-grow: 1;">{{'PROJECT.COMMON.NAME' | anessaTranslation}}</div>
      <ng-container *ngIf="templateType === 'form'">
        <div class="min-25">{{'PROJECT.PROJECT_INFO.CHECKLIST.TEMPLATE.TYPE' | anessaTranslation}}</div>
        <div class="min-25">{{'PROJECT.PROJECT_INFO.CHECKLIST.TEMPLATE.CREATED' | anessaTranslation}}</div>
      </ng-container>
      <div style="visibility: hidden;" class="remove-button">
        <button mat-raised-button disabled>{{'PROJECT.PROJECT_INFO.CHECKLIST.TEMPLATE.REMOVE' | anessaTranslation}}</button>
      </div>
    </div>
  </div>
</div>
<mat-dialog-content class="contents">
  <ng-container *ngIf="projectTemplates">
    <mat-selection-list class="loadList" #loadList [multiple]="false">
      <mat-list-option *ngFor="let template of projectTemplates; let i = index" class="list-row invisible-check-option"
        [value]="template.templateid" (click)="setLoadID(template.templateid)">
        <div class="list-row">
          <div style="flex-grow: 1;">{{template.name}}</div>
          <ng-container *ngIf="templateType === 'form'">
            <div class="min-25">{{template.formType | anessaTranslation}}</div>
            <div class="min-25">{{template.created}}</div>
          </ng-container>
          <div class="remove-button">
            <button color="red-hover-button" mat-raised-button color="warn" (click)="onRemoveTemplate(template.templateid)">
              {{'PROJECT.PROJECT_INFO.CHECKLIST.TEMPLATE.REMOVE' | anessaTranslation}}
            </button>
          </div>
        </div>
      </mat-list-option>
    </mat-selection-list>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions class="fatbuttongroup">
  <button mat-button class="btn-fat btn-green" type="button" [disabled]="greenButtonText === '-'" (click)="onSend()">
    {{greenButtonText}}
  </button>
  <button mat-button class="btn-fat btn-red" type="button" (click)="onCancel()"
    anessaTranslation="COMMON.CANCEL">
  </button>
</mat-dialog-actions>
